import { Injectable } from '@angular/core';
import { MasterDataRepository } from '../../../core/data/repositories/masterdata.repository';
import { TestDataRepository } from '../../../core/data/repositories/testdata.repository';
import { TestDetails } from '../model/test-details';
import { TestGoalResult, TestResult } from '../model/test-result';
import { TestInformation } from '../model/test-information';
import { TestInstallation } from '../model/test-installation';
import { timeout } from 'rxjs';
import { TestFilterDTO } from '../model/test-filter';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TestService {
  testInformation: TestInformation = {
    tstDetails: {} as TestDetails,
    testId: 0,
    tstInstallation: {} as TestDetails,
    projectId: 0,
    isEdit: true,
    tstElements: [],
    tstGoal: [],
    tstResult: [],
    canEdit: false
  };
  // private testTypeId: number = 0; 
  private testTypeId = new BehaviorSubject<number | null>(null);
  testTypeId$ = this.testTypeId.asObservable();

  constructor(
    private masterDataRepository: MasterDataRepository,
    private testDataRepository: TestDataRepository
  ) { }

  // getTestTypeId(): number {
  //   return this.testTypeId;
  // }

  // setTestTypeId(id: number): void {
  //   this.testTypeId = id;
  // }
   setTestTypeId(id: number) {
    this.testTypeId.next(id);
  }

  getTestTypeId() {
    return this.testTypeId.value;
  }

  getTestInformation(id: number): TestInformation {
    // if (id > 0) {
    //   this.testDataRepository
    //     .getTestDetails(id)
    //     .subscribe(
    //       (x: any) => (
    //         (this.testInformation.tstDetails = x),
    //         (this.testInformation.tstInstallation = x)
    //       )
    //     );
    // }
    return this.testInformation;
  }
  setResultData(result: any) {
    // console.log(result);
    // this.testInformation.tstResult = result;
  }

  setTestInformation(tInformation: TestInformation, reset: boolean = false) {
    if (reset)
      this.testInformation = {
        tstDetails: {} as TestDetails,
        testId: 0,
        tstInstallation: {} as TestDetails,
        projectId: 0,
        isEdit: true,
        tstElements: [],
        tstGoal: [],
        tstResult: [],
        canEdit: true
      };
    else {
      this.testInformation = tInformation;
      this.testInformation.tstInstallation = tInformation.tstDetails;
      if (this.testInformation.tstInstallation.testDate != undefined || this.testInformation.tstInstallation.testDate != null)
        this.testInformation.tstInstallation.testDate1 = new Date(this.testInformation.tstInstallation.testDate);
      if (this.testInformation.tstInstallation.installationDate != undefined || this.testInformation.tstInstallation.installationDate != null) {
      

        let arrInstallationDate = [];

        if (this.testInformation.tstInstallation.installationDate.includes(',')) {
          arrInstallationDate = JSON.parse(this.testInformation.tstInstallation.installationDate);
        } else {
          const singleDate = JSON.parse(this.testInformation.tstInstallation.installationDate);
          arrInstallationDate = Array.isArray(singleDate) ? singleDate : [singleDate];
        }
        this.testInformation.tstInstallation.installationDate1 = 
          arrInstallationDate.map(x => new Date(x));

      }
    }
  }

  //#region Master data call
  getInstituteType() {
    return this.masterDataRepository.getInstituteType();
  }
  getTestPurpose() {
    return this.masterDataRepository.getTestPurpose();
  }
  getSupportingConstruction() {
    return this.masterDataRepository.getSupConstruction();
  }
  getMountingDirection() {
    return this.masterDataRepository.getMountingDirection();
  }
  getTestOverview(pId: number) {
    return this.testDataRepository.getTestOverview(pId);
  }
  getTestType() {
    return this.masterDataRepository.getTestType();
  }
  getNorms(type: number) {
    return this.masterDataRepository.getStanardsByModule(2, type);
  }
  getTstwitness() {
    return this.masterDataRepository.getTstwitness();
  }
  getTstLabResponsible() {
    return this.masterDataRepository.getTstLabResponsible();
  }
  getTstInstiteLocation(type: number) {
    return this.masterDataRepository.getInstiteLocByType(type);
  }
  getTstInstiteLocationByTest(testId: number) {
    return this.masterDataRepository.getInstiteLocByTest(testId);
  }

  getInstituteLoc(includeInactive: boolean) {
    return this.masterDataRepository.getInstituteLoc(includeInactive);
  }

  getTstSponsors() {
    return this.masterDataRepository.getPartnerByType(2);
  }
  getTstInstaller() {
    return this.masterDataRepository.getTstInstaller();
  }
  getTstReason() {
    return this.masterDataRepository.getTstReason();
  }
  getTstValidate() {
    return this.masterDataRepository.getTstValidate();
  }
  getPerformanceCrtiterian(testId: number) {
    return this.masterDataRepository.getPerformanCriterian(2, testId);
  }
  getGlassBehavior() {
    return this.masterDataRepository.getGlassBehavior();
  }
  getComponentFailure() {
    return this.masterDataRepository.getComponentCausedFailure();
  }
  getResultUnit() {
    return this.masterDataRepository.getResultUnit();
  }
  //test page project dd
  getProjectList(prjName: string) {
    return this.masterDataRepository.getProjectList();
  }
  //#region for Dasboard
  getAllTestDetails(query) {
    return this.testDataRepository.getAllTestDetails(query);
  }
  //#endregion for Dasboard

  //#endregion

  getTestDetails(id: number) {
    var result: any;
    return new Promise<any>((resolve) => {
      this.testDataRepository.getTestDetails(id).subscribe(
        (data: any) => {
          result = data;
          let testInfo = this.getTestInformation(0);
          testInfo.tstDetails = data.value;
          testInfo.canEdit = data.bag.canEdit;
          this.setTestInformation(testInfo, false);
          resolve(result);
        },
        (error) => {
          resolve({});
        })
    });
  }

  getElementPerformance(testId: number) {
    return this.testDataRepository.getElementPerformance(testId);
  }
  updateTestEndReason(data: TestDetails): any {
    return this.testDataRepository.updateTestEndReason(data);
  }

  setTestDetails(data: TestDetails): any {
    return this.testDataRepository.saveTestDetails(data);
  }

  generateItiDocument(testId: number): any {
    return this.testDataRepository.generateItiDocument(testId);
  }


  generateTtrDocument(testId: number): any {
    return this.testDataRepository.generateTtrDocument(testId);
  }

  setTestInstallation(data: any): any {
    return this.testDataRepository.saveTestInstallation(data);
  }

  setTestGoalResult(data: TestGoalResult[]): any {
    this.testInformation.tstResult = [];
    this.testInformation.tstGoal = [];
    //data.forEach((val: any) => {
    return this.testDataRepository.saveTestResults(data);
    //});
  }

  setTestResult(data: TestResult[]): any {
    return this.testDataRepository
      .updateTestResult(data);
  }

  saveGoalresult(data: any) {
    return this.testDataRepository.saveGoalresult(data);
  }

  setTestElement(data: any): any {
    let id: number = 0;
    //this.testInformation.tstElements = [];
    const observable$ = this.testDataRepository.saveElement(data);
    observable$ //.pipe(timeout(500))
      .subscribe({
        next: (result) => {
          data.id = result;
          this.testInformation.tstElements.push(data);
          return this.testInformation.tstElements;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  getTestResult(id: number) {
    return this.testDataRepository.getTestResult(id);
  }

  saveTestResult(data: TestResult[]): any {
  }

  deleteTestGoal(ids: number[], elementId): any {
    return this.testDataRepository.deletePerformance(ids, elementId);
  }

  checkTestExternal(projectId: number, testPurposeId: number) {
    return this.testDataRepository.checkTestExternal(projectId, testPurposeId);
  }
  getSearch(data: TestFilterDTO) {
    return this.testDataRepository.search(data);
  }

  getExportSearch(data: TestFilterDTO) {
    return this.testDataRepository.export(data);
  }

  
  copyTest(id: number, projectId: number) {
    var model = { 'ProjectId': projectId, 'TestId': id }
    return this.testDataRepository.copy(model);
  }

  deleteTest(id: number, projectId: number) {
    return this.testDataRepository.deleteTest(id, projectId);
  }
}
